import { Children, cloneElement, isValidElement, useId } from "react";
import { PASSWORD_RULES } from "./superAdminRules";
import { labelStyle } from "./superAdminStyles";

const FIELD_CONTROLS = ["input", "select", "textarea"];

// Le libellé est relié au premier élément enfant (le champ) quand c'est un input, un select ou un textarea, pour les lecteurs d'écran et les tests.
export function Field({ label, hint, children }) {
    const generatedId = useId();
    const [control, ...rest] = Children.toArray(children);
    const bindable = isValidElement(control) && FIELD_CONTROLS.includes(control.type);
    const controlId = bindable ? (control.props.id ?? generatedId) : undefined;
    return (
        <div style={{ display: "flex", flexDirection: "column" }}>
            <label htmlFor={controlId} style={labelStyle}>
                {label}
                {hint && <span style={{ fontWeight: 400, color: "#9ca3af", marginLeft: "4px" }}>({hint})</span>}
            </label>
            {controlId ? cloneElement(control, { id: controlId }) : control}
            {rest}
        </div>
    );
}

export function PasswordConditions({ password }) {
    if (password.length === 0) return null;
    return (
        <div style={{ marginTop: "6px", display: "flex", flexDirection: "column", gap: "3px" }}>
            {PASSWORD_RULES.map(rule => {
                const ok = rule.test(password);
                return (
                    <span key={rule.label} style={{ fontSize: "11px", color: ok ? "#2e7d32" : "#c62828", display: "flex", alignItems: "center", gap: "4px" }}>
                        <span>{ok ? "✓" : "✗"}</span>
                        {rule.label}
                    </span>
                );
            })}
        </div>
    );
}

export function RoleOptions({ roles, label }) {
    return roles.map(role => <option key={role} value={role}>{label(role)}</option>);
}

export function setField(setForm, field, read = e => e.target.value) {
    return e => {
        const value = read(e);
        setForm(f => ({ ...f, [field]: value }));
    };
}
